/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUpaGuildResponse } from '../../models/get-upa-guild-response';

export interface UpaGuildServiceGetUpaGuild$Params {
  guildId: string;
}

export function upaGuildServiceGetUpaGuild(http: HttpClient, rootUrl: string, params: UpaGuildServiceGetUpaGuild$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUpaGuildResponse>> {
  const rb = new RequestBuilder(rootUrl, upaGuildServiceGetUpaGuild.PATH, 'get');
  if (params) {
    rb.path('guildId', params.guildId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUpaGuildResponse>;
    })
  );
}

upaGuildServiceGetUpaGuild.PATH = '/api/v3/gateway/upaguild/{guildId}';
